<div>
  <h2 mat-dialog-title>Delete Documents</h2>
  <mat-dialog-content>
    <h4 class="tw-pt-3">Are you sure you want to delete {{ data.length }} document(s)?</h4>
    <p class="document-title" *ngFor="let document of data">{{ document.title }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button color="primary" mat-dialog-close>No, Cancel</button>
    <button data-cy="doc-delete-confirm" mat-raised-button color="primary" (click)="deleteDocuments()">Yes, Delete</button>
  </mat-dialog-actions>
</div>
